import { StreamClient } from './StreamClient';
import HttpClient from '../../gateway/HttpClient';
import { StreamJsonModel } from '../../domain/stream/stream/StreamDomain';
import HttpMethod from '../../constant/HttpMethod';
import { StreamMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { ActionType } from '../../constant/Constants';
import Query = query.Query;

class NestStreamClient implements StreamClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public async save(stream: StreamJsonModel): Promise<void> {
    const dto = { id: stream.name, object: stream };
    return this.httpClient.execute(HttpMethod.POST, StreamMethods.SAVE, dto);
  }

  public async delete(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.DELETE, `${StreamMethods.REMOVE}/${id}`);
  }

  public async deploy(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${StreamMethods.DEPLOY}/${id}`);
  }

  public async undeploy(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${StreamMethods.UNDEPLOY}/${id}`);
  }

  public async isExist(id: string): Promise<boolean> {
    return this.httpClient.execute(HttpMethod.POST, `${StreamMethods.EXIST}/${id}`);
  }

  public async getCount(query: Query): Promise<number> {
    return this.httpClient.execute(HttpMethod.POST, StreamMethods.COUNT, query);
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, StreamMethods.BULK_ACTION, payload);
  }

  public getPermittedStores(): Promise<Record<string, StreamJsonModel[]>> {
    return this.httpClient.execute(HttpMethod.GET, StreamMethods.GET_PERMITTED_STORES);
  }
}

export default NestStreamClient;
